/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url === payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url === payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
  UPDATE_THEME(state, val) { state.theme = val },
  UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },

  UPDATE_EXPIRED_DATETIME(state, value) {
    state.expireTime = value
  },

  // /////////////////////////////////////////////
  // User/Account
  setMutationPercent(state, value) {
    state.percentage = value;
  },
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    console.log(state, payload, 'UPDATE_USER_INFO')
    // Get Data localStorage
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {
      // console.log(property,state.AppActiveUser)
      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        // console.log('asdasd',property, payload[property])
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }
    }

    let expired_time = userInfo.Expired_at
    state.expireTime = new Date(expired_time * 1000);

    // Store data in localStorage
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    console.log(userInfo.role, 'ppp', state.navMenu)
    if (userInfo.role == 'SUPERADMIN' || userInfo.role == 'DEVELOPER') {
      state.navMenu = [
        {
          url: '/home',
          name: 'Home',
          icon: 'HomeIcon',
          i18n: 'Home'
        },
        {
          url: "/group/list",
          name: 'Group Permission',
          icon: 'BoxIcon',
          i18n: 'Group',
        },
        {
          url: "/user/list",
          name: 'User',
          icon: 'UsersIcon',
          i18n: 'User',
        },
        {
          url: "/customer/list",
          name: 'Customer',
          icon: 'UsersIcon',
          i18n: 'Customer',
        },
        {
          url: "/loan/list",
          name: 'Loan',
          icon: 'BriefcaseIcon',
          i18n: 'Loan',
        },
        {
          url: "/report",
          name: 'Report',
          icon: 'BookIcon',
          i18n: 'Report',
        },
        {
          url: "/log",
          name: 'Log',
          icon: 'BookIcon',
          i18n: 'Log',
        }
      ]
    }
    else {
      console.log('update partner nav')
      state.navMenu = [
        {
          url: '/home',
          name: 'Home',
          icon: 'HomeIcon',
          i18n: 'Home'
        },
        {
          url: "/user/list",
          name: 'User',
          icon: 'UsersIcon',
          i18n: 'User',
        },
        {
          url: "/customer/list",
          name: 'Customer',
          icon: 'UsersIcon',
          i18n: 'Customer',
        },
        {
          url: "/loan/list",
          name: 'Loan',
          icon: 'BriefcaseIcon',
          i18n: 'Loan',
        },
        {
          url: "/report",
          name: 'Report',
          icon: 'BookIcon',
          i18n: 'Report',
        }
      ]
    }
  }
}

export default mutations

